import { render, staticRenderFns } from "./AssetDonation.vue?vue&type=template&id=713961d4&scoped=true"
import script from "./AssetDonation.vue?vue&type=script&lang=js"
export * from "./AssetDonation.vue?vue&type=script&lang=js"
import style0 from "./AssetDonation.vue?vue&type=style&index=0&id=713961d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713961d4",
  null
  
)

export default component.exports